import { render, staticRenderFns } from "./ProfileTab.vue?vue&type=template&id=735cc931&scoped=true&"
import script from "./ProfileTab.vue?vue&type=script&lang=js&"
export * from "./ProfileTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735cc931",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('735cc931')) {
      api.createRecord('735cc931', component.options)
    } else {
      api.reload('735cc931', component.options)
    }
    module.hot.accept("./ProfileTab.vue?vue&type=template&id=735cc931&scoped=true&", function () {
      api.rerender('735cc931', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/tabs/ProfileTab.vue"
export default component.exports